import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { PORTAL_AUTH_URL } from '@constants/index';
import type { PalmettoAccount } from '@/types';

/** Portal cognito account verification: the id_token in, the palmetto account out. */
export const authApi = createApi({
  reducerPath: 'authApi',
  keepUnusedDataFor: 60,
  baseQuery: fetchBaseQuery({ baseUrl: PORTAL_AUTH_URL }),
  endpoints: (builder) => ({
    verifyToken: builder.query<PalmettoAccount, string>({
      query: (token) => ({ url: '', headers: { Authorization: token } }),
    }),
  }),
});

export const { useVerifyTokenQuery } = authApi;
